<script>
  import { HStack, VStack, Spacer, Fixed, MediaQuery } from "./layout";
  import { Button, Icon } from "./widget";
  import { navigate } from "../router";

  export let guid;

  const doit = () => navigate(`#/quizz/${guid}/G`);
</script>

<article>
  <MediaQuery query="(min-width: 481px)">
    <VStack alignment="center">
      <img src="/images/champignon.svg" alt="champiz" width="48px" />
      <span>Champiz</span>
      <VStack>
        <p>Animer votre soirée de façon originale</p>
        <button class="primary" on:click={doit}>Commencer</button>
      </VStack>
    </VStack>
  </MediaQuery>
  <MediaQuery query="(max-width: 480px)">
    <Button action={doit}>
      <HStack alignment="center">
        <img src="/images/champignon.svg" alt="champiz" width="48px" />
        <span>Champiz</span>
        <Spacer />
        <Icon name="chevron-right" />
        <Fixed />
      </HStack>
    </Button>
  </MediaQuery>
</article>

<style>
  article {
    width: 100%;
    min-height: 48px;
    background-color: white;
    margin-top: 5px;
    padding-top: 5px;
  }
  span {
    margin-left: 1em;
  }

  @media (min-width: 481px) {
    article {
      padding: 1em;
      width: fit-content;
      min-width: 120px;
    }
  }

  p {
    font-size: smaller;
  }
</style>
